import { useEffect, useState } from "react";

import { useClientData } from "@/hooks/useClientData";
import { RACINGLeaderboard, RACINGWaitingScreen } from "@/clients";
import { RACINGEndScreen } from "@/clients/RACING/RACING_endScreen";
import { brand } from "@/brandVariables/getBandVariables";

const components = [RACINGWaitingScreen, RACINGLeaderboard, RACINGEndScreen];

export const PreviewMode = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { clientData } = useClientData(brand.client, true);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % components.length);
    }, 10000); // 10 seconds

    return () => clearInterval(interval);
  }, []);

  const CurrentComponent = components[currentIndex];

  return <CurrentComponent clientData={clientData} />;
};
